import React, { useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import VariantSelector from '../components/VariantSelector';
import './SelectVariant.css';

const SelectVariant = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const handleVariantSelect = (variant) => {
    const key = variant.slug || variant.id;
    navigate(`/cars/${key}`);
  };

  return (
    <div className="select-variant-page">
      <div className="variant-page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/" className="breadcrumb-link">
              الرئيسية
            </Link>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">اختيار السيارة</span>
          </div>
          <h1 className="page-title">اختر سيارتك</h1>
          <p className="page-subtitle">
            اختر من بين السيارات المتاحة لموديلك وابدأ استكشاف القطع المتاحة
          </p>
        </div>
      </div>
      <div className="container">
        <VariantSelector modelKey={slug} onSelectVariant={handleVariantSelect} />
      </div>

      <div className="variant-info-section">
        <div className="container">
          <div className="info-card">
            <h3>💡 نصيحة</h3>
            <p>
              تأكد من اختيار السيارة الصحيحة للحصول على القطع المناسبة تماماً. يمكنك استكشاف السيارة بشكل
              تفاعلي بعد الاختيار.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectVariant;
